<template>
  <v-card>
    <v-card-title class="title">Fuentes</v-card-title>
    <v-card-text></v-card-text>
  </v-card>
</template>

<script>

export default {
  mounted() {
    this.loadSources();
  },
  methods: {
    loadSources() {
      this.$http.get(`/api/admin/sources`).then((response) => {
        console.log(response);
      });
    },
  },
};
</script>

<style>
</style>